/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DomainDTO,
    DomainDTOFromJSON,
    DomainDTOFromJSONTyped,
    DomainDTOToJSON,
} from './DomainDTO';

/**
 * 
 * @export
 * @interface DomainDTOPagedResponse
 */
export interface DomainDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof DomainDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DomainDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof DomainDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DomainDTO>}
     * @memberof DomainDTOPagedResponse
     */
    data?: Array<DomainDTO> | null;
}

export function DomainDTOPagedResponseFromJSON(json: any): DomainDTOPagedResponse {
    return DomainDTOPagedResponseFromJSONTyped(json, false);
}

export function DomainDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(DomainDTOFromJSON)),
    };
}

export function DomainDTOPagedResponseToJSON(value?: DomainDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(DomainDTOToJSON)),
    };
}

